import { Link } from "react-router-dom"
import { DocumentTextIcon } from "@heroicons/react/24/outline"
import { useStatementsNeedingAttention } from "@/hooks/useAffiliateStatements"
import { formatCents, formatDateUtc, periodLabel } from "@/lib/affiliateStatements"

const KIND_TEXT = {
  ready_to_send: "ready to send",
  payment_due: "payment due",
  payment_overdue: "payment overdue",
} as const

/** Affiliate statements waiting on a person. Renders nothing when there are none. */
export function StatementsNeedingAttention() {
  const { data } = useStatementsNeedingAttention()
  const items = data?.items ?? []
  if (items.length === 0) return null

  return (
    <section className="rounded-lg border border-border bg-surface p-5 space-y-3">
      <h2 className="text-lg font-semibold text-primary flex items-center gap-2">
        <DocumentTextIcon className="h-5 w-5 text-secondary" />
        Needs attention
      </h2>
      <ul className="space-y-1.5 text-sm">
        {items.map((item) => {
          const overdue = item.kind === "payment_overdue"
          return (
            <li key={item.statement_public_id}>
              <Link
                to={`/affiliate-statements/${item.statement_public_id}`}
                className={`hover:underline ${overdue ? "text-amber-400 font-medium" : "text-primary"}`}
              >
                {item.affiliate.name}, {periodLabel(item.period_start, item.period_end)}:{" "}
                {KIND_TEXT[item.kind]}
                {item.kind === "ready_to_send" && item.has_warnings ? " (has warnings)" : ""}
                {item.amount_due_cents > 0
                  ? `, ${formatCents(item.amount_due_cents)} due ${formatDateUtc(item.payment_due_at)}`
                  : ", nothing due"}
              </Link>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
